module.exports = __webpack_public_path__ + "img/Wp_2004.70e231ab.png";